// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lZvA","comment":"styles_comment__1rX2E"};